import {INotification, NotificationsRepository} from './notifications.repository';
import {createStore, withProps} from '@ngneat/elf';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

const notificationStore = createStore(
  {name: 'userNotification'},
  withProps<INotification>({token: ''})
);


@Injectable()
export class NotificationsRepositoryImpl implements NotificationsRepository {
  notification$: Observable<INotification>;

  constructor() {

  }

  renewToken(token: string): Promise<void> {
    notificationStore.update((state) => ({
      ...state,
      token
    }));
    return Promise.resolve(undefined);
  }

}
